import React, { useEffect, useState } from "react";
import { Modal, Row, Card, Button, Col, Spinner } from "react-bootstrap";
import ApiGallery from "../../../core/api/api.gallery";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { FormProvider, useForm, Controller } from "react-hook-form";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import Paging from "../_Components/Paging";
import Select from "react-select";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import SelectComponent from "../_Components/ReactSelectComponent";
function SelectImageModal(props) {
  const [listData, setListData] = useState([]);
  const [listOption, setListOption] = useState([]);
  const [listType, setListType] = useState([]);
  const [checkBoxList, setCheckBoxList] = useState([]);
  const [listSelective, setListSelective] = useState([]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({ defaultValues: { pageSize: 10, pageNumber: 1 } });
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };

  useEffect(() => {
    (async () => {
      try {
        const galleryOptionList = (await ApiGallery.getGalleryOption()).data.filter(item => item.value != 3);
        setListOption(galleryOptionList);
        const galleryTypeList = (await ApiGallery.getGalleryType()).data.filter(item => item.value != 7);
        setListType(galleryTypeList);
        if (_.isNumber(props.option) && props.option > 0) {
          const options = galleryOptionList?.map((item) => ({
            value: item.id,
            label: item.title,
          }))
          const foundedSelectedOption = options.find(op => op.value == props.option)
          setValue("option", foundedSelectedOption);
        }
        if (_.isNumber(props.type) && props.type > 0) {
          const options = galleryTypeList?.map((item) => ({
            value: item.id,
            label: item.title,
          }))
          const foundedSelectedType = options.find(op => op.value == props.type)
          setValue("type", foundedSelectedType);
          //لیست ایتم های وابسته به انتخاب نوع فایل
          const apiData = await ApiGallery.getSelectiveListByGalleryType({ Type: props.type });
          if (apiData.succeeded) {
            setListSelective(apiData?.data);
            const options = apiData?.data?.map((item) => ({
              value: item.id,
              label: item.title,
            }))
            setValue("selectedId", options.find(op => op.value == props.selectedId));
          }
        }

        const data = {
          type: props.type,
          option: props.option,
          selectedId: props.selectedId,
          pageNumber: getValues("pageNumber"),
          pageSize: getValues("pageSize"),
        };
        const apiData2 = await ApiGallery.getAllGallery(data);
        if (apiData2.succeeded) {
          setListData(apiData2.data);
          setValue("totalCount", apiData2.totalCount);
        }
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  const handlelistTypeChange = async (value) => {
    if (value)
      setValue("type", { label: value.label, value: value.value });
    else setValue("type", null)
    if (_.isNumber(value?.value) && value?.value > 0) {
      //لیست ایتم های وابسته به انتخاب نوع فایل
      const apiData = await ApiGallery.getSelectiveListByGalleryType({ Type: value?.value });
      if (apiData.succeeded) {
        setListSelective(apiData?.data);
        const options = apiData?.data?.map((item) => ({
          value: item.id,
          label: item.title,
        }))
        const foundedSelectedItem = options.find(op => op.value == getValues("selectedId")?.value)
        if (foundedSelectedItem && props.type == value?.value)
          setValue("selectedId", foundedSelectedItem);
        else
          setValue("selectedId", undefined);
      } else {
        //SwalMessage({ title: apiData.message, iSsuccess: false });
        setListSelective([]);
        setValue("selectedId", undefined);
      }
    }
    else {
      setListSelective([]);
      setValue("selectedId", undefined);
    }
  };

  const onSubmit = async (data) => {
    data.selectedId = data.selectedId?.value
    data.type = data.type?.value
    data.option = data.option?.value
    data.pageNumber = getValues("pageNumber");
    const apiData = await ApiGallery.getAllGallery(data);
    // const apiData = await ApiGallery.getAllGallery(data);
    if (apiData.succeeded) {
      setListData(apiData.data);
      setValue("totalCount", apiData.totalCount);
    } else SwalMessage({ title: apiData.message, iSsuccess: false });
  };

  const handleSelect = (id) => {
    const data = id;
    checkBoxList.some((item) => data === item)
      ? setCheckBoxList((checkBoxList) => checkBoxList.filter((item) => item != data))
      : setCheckBoxList((checkBoxList) => [...checkBoxList, data]);
  };

  const callBack = () => {
    props.callBack(checkBoxList);
    props.show(false);
  };

  return (
    <Modal show={true} size="xl" onHide={(event) => props.show(false)}>
      <Modal.Header>
        <Modal.Title>افزودن عکس به سرویس </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormProvider {...methods}>
          <form id="form" onSubmit={handleSubmit(onSubmit)}>
            <Row className=" mb-5">
              <Col xs="12" sm="6" lg>
                <Controller
                  name="option"
                  control={control}
                  render={({ field }) => (
                    <SelectComponent
                      options={listOption?.map((item) => ({
                        value: item.id,
                        label: item.title,
                      }))}
                      placeholder="نوع فایل"
                      field={field}
                      className="w-100 mt-2"
                    />
                  )}
                />
                {/* {errors.type && <span>لطفا نوع فایل را وارد نمایید</span>} */}
              </Col>
              <Col xs="12" sm="6" lg>
                <Controller
                  name="type"
                  control={control}
                  // rules={{ required: true, }}
                  render={({ field }) => (
                    <SelectComponent
                      options={listType?.map((item) => ({
                        value: item.id,
                        label: item.title,
                      }))}
                      placeholder="دسته"
                      field={field}
                      className="w-100 mt-2"
                      onChange={handlelistTypeChange}
                    />
                  )}
                />
                {/* {errors.type && <span>لطفا دسته را وارد نمایید</span>} */}
              </Col>
              <Col xs="12" sm="6" lg>
                <Controller
                  name="selectedId"
                  control={control}
                  // rules={{ required: true, }}
                  render={({ field: { onChange, value } }) => (
                    <Select
                      inputId="react-select-with-search"
                      className="w-100 mt-2"
                      variant="outlined"
                      size="small"
                      // label="گروه"
                      options={listSelective?.map((item) => ({
                        value: item.id,
                        label: item.title,
                      }))}
                      value={value || ""}
                      onChange={onChange}
                    />
                  )}
                />
              </Col>

              <Col xs="12" sm="2" lg="auto">
                <Button
                  className="mt-2 px-5"
                  variant="secondary"
                  type="submit"
                  disabled={isSubmitting}
                  style={{ height: "36px" }}
                >
                  {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                  <SearchIcon />
                </Button>
              </Col>
            </Row>
            <hr />
            {listData?.length > 0 ? (
              <>
                <Row className="d-flex flex-wrap justify-content-center mt-5 ">
                  {listData?.map((item, index) => (
                    <Card style={{ width: "15rem" }} key={index} className="mb-4 mx-3 mt-4">
                      {item.option == 1 || item.option == 3
                        ? <Card.Img
                          variant="top"
                          title={item.imageAlt}
                          src={process.env.REACT_APP_MEDIA_URL + item.imageUrl}
                          alt={item.imageAlt}
                          height="120px"
                          className="bg-light-primary"
                        />
                        : <video
                          width="100%"
                          height="100%"
                          style={{ maxHeight: 200 }}
                          src={process.env.REACT_APP_MEDIA_URL + item.imageUrl}
                          alt={item.imageAlt}
                        />
                      }
                      <Card.Body className=" py-0 px-0 ">
                        <Row>
                          <Col xs="10">
                            <p className="mt-2 pl-2 "> {item.imageAlt} </p>
                          </Col>
                          <Col xs="2" className=" px-0 " onClick={() => handleSelect(item.id)}>
                            <input
                              type="checkbox"
                              defaultChecked={checkBoxList.some((item1) => item.id === item1)}
                              className="pr-4  mr-2 mt-3"
                            />
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  ))}
                </Row>
                <Paging config={config} {...methods} />
              </>
            ) : (
              <p>فایلی برای این جستجو پیدا نشد !</p>
            )}
          </form>
        </FormProvider>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={callBack}>
          <SaveIcon className="mr-1" />
          ثبت
        </Button>
        <Button variant="danger" onClick={(event) => props.show(false)}>
          <CloseIcon />
          بستن
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SelectImageModal;
